module.exports = __webpack_public_path__ + "img/760e89a.png";